import { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import Home from "./Home";
import MainLayout from "../layout";
import ClientSection from "./Implementation/ClientSection";
import PowerBi from "./PowerBi/PowerBi";
import { DisplayMsg } from "../../services/toastService";
import { setUrl } from "../../handlers";
import { setSalesPersonList } from "../../store/reducers/SharedLayoutDataSlice";

export default function Dashboard() {
  const dispatch = useDispatch();

  const [Type, setType] = useState("support");
  const [reRender, setRender] = useState(false);

  const SectionRender = useMemo(
    () => ({
      reRender,
    }),
    [reRender]
  );

  useEffect(() => {
    if (
      !(
        sessionStorage.type === "SA" &&
        sessionStorage.viewOnly === "N" &&
        sessionStorage.fullAccess === "Y"
      )
    ) {
      if (sessionStorage.type !== "SP") {
        LoadSharedData();
      }
    }
  }, []);

  const LoadSharedData = () => {
    const userType = sessionStorage.type.toUpperCase();
    if (userType !== "A" && userType !== "SP" && userType !== "SA") {
      LoadUserPrefrencesList();
    }
    LoadSalesPersons();
  };

  const LoadSalesPersons = () => {
    const salesPersonArr = [];
    try {
      const salesPerson = {
        label: "- Select -",
        value: "",
      };
      salesPersonArr.push(salesPerson);
      fetch(setUrl("CLIENTDETAIL", "LOADSALESUSERS", true))
        .then((response) => response.json())
        .then((data) => {
          document.getElementById("loader").style.display = "none";
          const salesUsers = data.salesUser;
          salesUsers.map((sales) => {
            const data = {
              label: sales,
              value: sales.toUpperCase(),
            };
            salesPersonArr.push(data);
          });

          dispatch(setSalesPersonList(salesPersonArr));
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const LoadUserPrefrencesList = async () => {
    try {
      const formData = new FormData();
      formData.append("USERSEQNUM", sessionStorage.SEQ_NUM);
      const result = await fetch(setUrl("HOME", "LOADUSERPREFRENCES", true), {
        method: "POST",
        body: formData,
      });
      const response = await result.json();
      if (response.status) {
        const userPData = JSON.parse(response.userPData);
        if (userPData) {
          SetUserPrefrences(userPData);
        }
      } else {
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const SetUserPrefrences = (PreferenceArray) => {
    PreferenceArray.forEach((item, key) => {
      if (PreferenceArray[key].TYPE === "COMMENTS") {
        sessionStorage.setItem("CNT", PreferenceArray[key].NOTIFICATION_TYPE);
        sessionStorage.setItem("CNT_SEQ_NUM", PreferenceArray[key].SEQ_NUM);
      }
      if (PreferenceArray[key].TYPE === "ASSIGNEE") {
        sessionStorage.setItem("ANT", PreferenceArray[key].NOTIFICATION_TYPE);
        sessionStorage.setItem("ANT_SEQ_NUM", PreferenceArray[key].SEQ_NUM);
      }
      if (PreferenceArray[key].TYPE === "TEAM") {
        sessionStorage.setItem("TNT", PreferenceArray[key].NOTIFICATION_TYPE);
        sessionStorage.setItem("TNT_SEQ_NUM", PreferenceArray[key].SEQ_NUM);
      }

      if (PreferenceArray[key].TYPE === "STATUS") {
        sessionStorage.setItem("S", PreferenceArray[key].NOTIFICATION_TYPE);
        sessionStorage.setItem("S_SEQ_NUM", PreferenceArray[key].SEQ_NUM);
      }
    });
  };
  const TriggerTab = (type) => {
    if (type === "imp") {
      setType(type);
    } else {
      setType(type);
    }
  };

  return (
    <MainLayout>
        <div className="errorMsgPanel" />
        <div className="successMsgPanel" />
        <div id="page-content-wrapper">
          <div className="container-fluid">
            {(sessionStorage.type === "CS" ||
              sessionStorage.type === "I" ||
              sessionStorage.type === "M" ||
              sessionStorage.type === "CSM") &&
              sessionStorage.viewOnly === "N" &&
              sessionStorage.fullAccess === "Y" && (
                <div className="row">
                  <div>
                    <ul className="tabComment">
                      <li
                        className={`${
                          Type === "support" ? "bg-gray-400" : ""
                        } commentHeading`}
                        onClick={() => TriggerTab("support")}
                      >
                        <span>Support</span>
                      </li>
                      <li
                        className={`${
                          Type === "imp" ? "bg-gray-400" : ""
                        } commentHeading`}
                        onClick={() => TriggerTab("imp")}
                      >
                        <span>Implementation</span>
                      </li>
                    </ul>
                  </div>
                  <hr style={{ border: "1px solid #026fb9" }} />
                </div>
              )}
            <div className="row">
              <div className="col-lg-12">
                <div className="demo">
                  <div role="tabpanel">
                    <div className="tab-content">
                      {Type === "support" ? (
                        (((sessionStorage.type === "S" ||
                          sessionStorage.type === "D" ||
                          sessionStorage.type === "") &&
                          sessionStorage.viewOnly === "N" &&
                          sessionStorage.fullAccess === "N") ||
                          ((sessionStorage.type === "CS" ||
                            sessionStorage.type === "IT" ||
                            sessionStorage.type === "I" ||
                            sessionStorage.type === "M" ||
                            sessionStorage.type === "CSM") &&
                            sessionStorage.viewOnly === "N" &&
                            sessionStorage.fullAccess === "Y")) && (
                          <div
                            role="tabpanel"
                            className="active"
                            id="dashboard"
                          >
                            <Home />
                          </div>
                        )
                      ) : Type === "powerBi" ? (
                        <div>
                          <PowerBi />
                        </div>
                      ) : (
                        <div>
                          <ClientSection />
                        </div>
                      )}

                      {(sessionStorage.type === "SP" ||
                        sessionStorage.type === "SA") &&
                        sessionStorage.viewOnly === "N" &&
                        (sessionStorage.fullAccess === "N" ||
                          sessionStorage.fullAccess === "Y") && (
                          <div>
                            <ClientSection data={SectionRender} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
  );
}
